import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useAdditionalPropertyValues } from './useAdditionalPropertyValues';
import { isReadOnlyPaymentProperty } from 'customer-data-objects/payment/isReadOnlyPaymentProperty';
export const useIsReadOnlyPaymentProperty = (objectTypeId, propertyDefinition) => {
  const {
    data,
    loading
  } = useAdditionalPropertyValues({
    // Controlling property - Whether Hubspot payments is enabled for this payment
    // https://tools.hubteam.com/lighthouse/objects/COMMERCE_PAYMENT/properties/hs_hubspot_payments_enabled/details/0
    hs_hubspot_payments_enabled: 'hs_hubspot_payments_enabled'
  }, {
    skip: objectTypeId !== COMMERCE_PAYMENT_TYPE_ID || !propertyDefinition.hubspotDefined
  });
  if (loading) {
    return true;
  }
  return isReadOnlyPaymentProperty({
    objectTypeId,
    property: propertyDefinition,
    paymentsEnabled: data === null || data === void 0 ? void 0 : data.hs_hubspot_payments_enabled
  });
};